import { render } from "./SettingsDesign.vue?vue&type=template&id=558f77f0"
import script from "./SettingsDesign.vue?vue&type=script&lang=js"
export * from "./SettingsDesign.vue?vue&type=script&lang=js"

import "./SettingsDesign.vue?vue&type=style&index=0&id=558f77f0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__